export default __webpack_public_path__ + "static/media/banner.f60e513d.svg";